import axios from "axios";
import React, { useEffect, useState } from "react";
import { Card, Container } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Breadcrumb from "../Component/BradeCrum";
import HeaderMobile from "../Component/MobileHader";
import { Hourglass } from "react-loader-spinner";

const formatDate = (date) =>
  new Date(date).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });

const EventDetails = () => {
  const { _id } = useParams();
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    setLoading(true); // Show loader before making the API call
    setImageFailed(false);

    axios
      .get(`${process.env.REACT_APP_GRIPHOLD_API_URL}/api/auth/get/event/${_id}`)
      .then((res) => {
        // Inactive events are hidden on the website
        setContent(res.data && res.data.IsActive ? res.data : null);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setContent(null);
        setLoading(false);
      });

    window.scrollTo(0, 0);
  }, [_id]);

  const title = content ? content.Title : "Events";

  return (
    <React.Fragment>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <Hourglass
            height={80}
            width={80}
            color="#01458e"
            ariaLabel="loading-content"
          />
        </div>
      ) : (
        <div>
          <HeaderMobile />
          <Breadcrumb
            heading={title}
            bTitle={title}
            midTitle={content ? { name: "Events", url: "/events" } : null}
          />
          <Container className="galleryRow ">
            <div className="sub-title text-animation">
              <h6>
                Events
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={50}
                  height={6}
                  viewBox="0 0 50 6"
                >
                  <path d="M50 3L45 0.113249V5.88675L50 3ZM0 3.5H45.5V2.5H0V3.5Z" />
                </svg>
              </h6>
            </div>

            {!content ? (
              <p>Event not found.</p>
            ) : (
              <React.Fragment>
                <div className="positionTitle">
                  <span>Date : </span>
                  {formatDate(content.EventDate)}
                </div>
                {/* Banner is optional, so skip the card when it is missing or fails to load */}
                {content.EventImage && !imageFailed && (
                  <Card className="serviceCardNew">
                    <img
                      src={`${process.env.REACT_APP_GRIPHOLD_API_URL}/${content.EventImage}`}
                      onError={() => setImageFailed(true)}
                      alt="img"
                      className="whats-new-modal-img"
                    />
                  </Card>
                )}
                {content.Description && (
                  <Card className="serviceCardNew">
                    <div dangerouslySetInnerHTML={{ __html: content.Description }}></div>
                  </Card>
                )}
              </React.Fragment>
            )}
          </Container>
        </div>
      )}
    </React.Fragment>
  );
};

export default EventDetails;
